/* ZaragozaShop · filtros de colección (móvil): el desplegable abierto se saca del carril y flota bajo su botón.
   No cambia la lógica de filtrado: los controles siguen ligados al formulario (atributo form="fbar"). */
(function () {
  var form = document.getElementById('fbar'); if (!form) return;
  var mq = window.matchMedia('(max-width:879px)');
  var row = form.querySelector('.fbar-row');
  var floating = null;   /* { d: details, p: panel } */

  /* los controles de los paneles pertenecen al formulario aunque el panel se mueva al body */
  form.querySelectorAll('.fpanel input, .fpanel button').forEach(function (el) { if (!el.hasAttribute('form')) el.setAttribute('form', 'fbar'); });

  function stop(e) {
    e.stopPropagation();   /* que theme.js no lo interprete como "clic fuera" */
    var b = e.target.closest && e.target.closest('button[name="sort_by"]');
    var keep = document.getElementById('sortKeep');
    if (b && keep) keep.disabled = true;   /* que no viaje también el orden antiguo */
  }

  function floatOut(d) {
    if (!mq.matches) return;
    var p = d.querySelector(':scope > .fpanel'), s = d.querySelector(':scope > summary');
    if (!p || !s) return;
    if (floating && floating.d !== d) floatBack();
    var r = s.getBoundingClientRect();
    document.body.appendChild(p);
    p.classList.add('fpanel--float');
    p.addEventListener('click', stop);
    p.style.top = Math.round(r.bottom + 6) + 'px';
    var w = Math.min(p.offsetWidth || 260, window.innerWidth - 24);
    p.style.left = Math.round(Math.min(Math.max(12, r.left), window.innerWidth - 12 - w)) + 'px';
    floating = { d: d, p: p };
  }
  function floatBack() {
    if (!floating) return;
    var p = floating.p, d = floating.d;
    p.removeEventListener('click', stop);
    p.classList.remove('fpanel--float');
    p.style.top = ''; p.style.left = '';
    d.appendChild(p);
    floating = null;
  }
  function closeAll(except) {
    form.querySelectorAll('details.fdrop[open]').forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
  }

  form.querySelectorAll('details.fdrop').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) { closeAll(d); floatOut(d); } else if (floating && floating.d === d) { floatBack(); }
    });
  });

  /* marcar una talla en el panel flotante aplica el filtro (igual que dentro del formulario) */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.type === 'checkbox' && el.closest && el.closest('.fpanel--float')) form.submit();
  });
  /* tocar fuera del panel flotante lo cierra */
  document.addEventListener('click', function (e) {
    if (!floating) return;
    if (floating.p.contains(e.target) || floating.d.contains(e.target)) return;
    floating.d.removeAttribute('open');
  });
  form.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fclose]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  window.addEventListener('scroll', function () { if (floating) closeAll(); }, { passive: true });
  if (row) row.addEventListener('scroll', function () { if (floating) closeAll(); }, { passive: true });
  mq.addEventListener ? mq.addEventListener('change', function () { closeAll(); }) : mq.addListener(function () { closeAll(); });
})();
